import z from "zod";
//
// Entity
//
export const DTOSandboxTemplatePreset = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    thumbnailUrl: z.string().optional(),
    files: z.string().array(),
});
export const DTOSandboxTemplateVersion = z.object({
    name: z.string(),
    createdAt: z.string(),
    createdByUserId: z.string(),
    e2bTemplateId: z.string(),
    templates: DTOSandboxTemplatePreset.array().optional(),
    hasDesignModePlugin: z.boolean().optional(),
});
export const DTOSandboxTemplate = z.object({
    id: z.string(),
    name: z.string(),
    workspaceId: z.string(),
    designSystemId: z.string(),
    createdAt: z.string(),
    versions: DTOSandboxTemplateVersion.array(),
});
export const DTOSandboxTemplateBuild = z.object({
    id: z.string(),
    workspaceId: z.string(),
    designSystemId: z.string(),
    name: z.string(),
    version: z.string(),
    createdAt: z.string(),
    finishedAt: z.string().optional(),
    createdByUserId: z.string(),
    /** @deprecated use `dockerImageUri` instead */
    dockerImagePath: z.string().optional(),
    dockerImageUri: z.string(),
    state: z.enum(["PendingUpload", "Building", "Success", "Failure", "Timeout"]),
    error: z.string().optional(),
});
export const DTOSandboxTemplateFile = z.object({
    key: z.string(),
    fileId: z.string(),
    filePath: z.string(),
    url: z.string(),
});
export const DTOSandboxTemplateVersionDetail = z.object({
    version: DTOSandboxTemplateVersion,
    files: DTOSandboxTemplateFile.array(),
});
//
// Read
//
export const DTOSandboxTemplateQuery = z.object({
    workspaceId: z.string(),
    designSystemId: z.string().optional(),
});
export const DTOSandboxTemplateListResponse = z.object({
    templates: DTOSandboxTemplate.array(),
});
export const DTOSandboxTemplateResponse = z.object({
    template: DTOSandboxTemplate,
});
export const DTOSandboxTemplateBuildResponse = z.object({
    build: DTOSandboxTemplateBuild,
});
//
// Write
//
export const DTOSandboxTemplateBuildCreateInput = z.object({
    workspaceId: z.string(),
    designSystemId: z.string(),
    name: z.string(),
    version: z.string(),
    isExistingVersionUpdateAllowed: z.boolean(),
    hasDesignModePlugin: z.boolean().optional(),
    dockerImageUri: z.string().optional(),
    customAuth: z
        .object({ username: z.string(), password: z.string() })
        .optional(),
    templates: z
        .object({
        id: z.string(),
        name: z.string(),
        description: z.string(),
        thumbnailUrl: z.string().optional(),
        files: z.string().array(),
    })
        .array()
        .optional(),
});
export const DTOSandboxTemplateBuildTriggerInput = z.object({
    imageFileId: z.string().optional(),
});
export const DTOSandboxTemplateBuildCreateResponse = z.object({
    /** @deprecated use build.dockerImageUri */
    dockerUrl: z.string().optional(),
    /** @deprecated use build.dockerImageUri */
    dockerRegistryDomain: z.string().optional(),
    /** @deprecated use docker-login endpoint */
    dockerAccessToken: z.string().optional(),
    build: DTOSandboxTemplateBuild,
});
export const DTOSandboxTemplateBuildFinalizeResponse = z.object({
    ok: z.boolean(),
});
